import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from '../assets/maskan_logo.png';

export default function Sidebar() {
  const IconDashboard = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="8" height="8" rx="2"/>
      <rect x="13" y="3" width="8" height="5" rx="2"/>
      <rect x="13" y="10" width="8" height="11" rx="2"/>
      <rect x="3" y="13" width="8" height="8" rx="2"/>
    </svg>
  );
  const IconVoice = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="2" width="6" height="12" rx="3"/>
      <path d="M5 10v1a7 7 0 0 0 14 0v-1"/>
      <path d="M12 19v3"/>
    </svg>
  );
  const IconRadiology = () => (
    <svg viewBox="0 0 48 48" width="18" height="18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="m39 44h-30c-2.757 0-5-2.243-5-5v-30c0-2.757 2.243-5 5-5h30c2.757 0 5 2.243 5 5v30c0 2.757-2.243 5-5 5zm-30-38c-1.654 0-3 1.346-3 3v30c0 1.654 1.346 3 3 3h30c1.654 0 3-1.346 3-3v-30c0-1.654-1.346-3-3-3z"></path>
      <path d="m9 13c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1h3c.552 0 1 .448 1 1s-.448 1-1 1h-2v2c0 .552-.448 1-1 1z"></path>
      <path d="m39 13c-.552 0-1-.448-1-1v-2h-2c-.552 0-1-.448-1-1s.448-1 1-1h3c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1z"></path>
      <path d="m12 40h-3c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1s1 .448 1 1v2h2c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m39 40h-3c-.552 0-1-.448-1-1s.448-1 1-1h2v-2c0-.552.448-1 1-1s1 .448 1 1v3c0 .552-.448 1-1 1z"></path>
      <path d="m25 13h-2c-.552 0-1-.448-1-1s.448-1 1-1h2c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m24.5 17h-1c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m24.5 21h-1c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m24.5 25h-1c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m24.5 29h-1c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m24.5 33h-1c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m25 37h-2c-.552 0-1-.448-1-1s.448-1 1-1h2c.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m29 19c-.552 0-.999-.447-1-.999s.447-1 .999-1.001c1.395-.003 4.001-.446 4.001-1.5 0-1.458-1.795-1.5-2-1.5-.552 0-1-.448-1-1s.448-1 1-1c1.383 0 4 .731 4 3.5 0 3.402-5.386 3.5-6 3.5z"></path>
      <path d="m29 24c-.552 0-.999-.447-1-.999 0-.552.447-1 .999-1.001 1.785-.003 4.591-.541 4.946-1.686.163-.528.722-.824 1.251-.659.527.163.823.723.659 1.251-.931 3.007-6.251 3.094-6.855 3.094z"></path>
      <path d="m29 29c-.552 0-1-.447-1-1 0-.552.447-1 .999-1 2.394-.002 5.808-.657 5.992-1.878.082-.547.597-.925 1.137-.84.546.082.922.591.84 1.137-.512 3.409-6.728 3.582-7.969 3.582z"></path>
      <path d="m29 34c-.552 0-.999-.447-1-.999 0-.552.447-1 .999-1.001 1.45-.002 4.033-.38 4.794-1.384.334-.44.961-.527 1.401-.193s.526.961.193 1.401c-1.604 2.115-5.902 2.176-6.387 2.176z"></path>
      <path d="m18.98 19c-.614 0-6-.098-6-3.5 0-2.769 2.617-3.5 4-3.5.552 0 1 .448 1 1s-.448 1-1 1c-.33.003-2 .093-2 1.5 0 1.06 2.605 1.5 4 1.5.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m18.98 24c-.604 0-5.924-.087-6.855-3.094-.164-.528.132-1.088.659-1.251.526-.165 1.088.131 1.251.659.356 1.15 3.161 1.686 4.945 1.686.552 0 1 .448 1 1s-.448 1-1 1z"></path>
      <path d="m18.98 29c-1.241 0-7.457-.173-7.969-3.582-.082-.546.294-1.055.84-1.137.541-.085 1.056.293 1.137.84.184 1.221 3.598 1.876 5.992 1.878.552 0 1 .449.999 1 0 .552-.447 1-1 1z"></path>
      <path d="m18.98 34c-.485 0-4.783-.061-6.387-2.175-.333-.44-.248-1.067.192-1.401.44-.333 1.067-.248 1.401.192.761 1.003 3.344 1.382 4.794 1.384.552 0 .999.449.999 1.001s-.448.999-1 .999z"></path>
    </svg>
  );
  const IconChat = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/>
      <path d="M8 9h8M8 13h5"/>
    </svg>
  );
  const IconWhatsApp = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 20l1.6-4.8A8 8 0 1 1 12 20a8.5 8.5 0 0 1-3.3-.7z"/>
      <path d="M16.5 14.5c-1 .7-2.2 1-3.5.5-2-1-3.5-2.6-4.5-4.5-.6-1.3-.2-2.5.5-3.5l1.2 1.2c.3.3.4.8.2 1.2-.2.5-.2 1 .1 1.4.6.9 1.5 1.7 2.4 2.3.4.3.9.3 1.4.1.4-.2.9-.1 1.2.2z"/>
    </svg>
  );
  const IconAvatar = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="7" r="4"/>
      <path d="M5.5 21a8.5 8.5 0 0 1 13 0"/>
    </svg>
  );
  const IconDoc = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2h9l3 3v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"/>
      <path d="M15 2v3h3"/>
      <path d="M8 9h8M8 13h8M8 17h5"/>
    </svg>
  );
  const IconLogout = () => (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
      <path d="M16 17l5-5-5-5"/>
      <path d="M21 12H9"/>
    </svg>
  );
  return (
    <aside className="sidebar" style={{ display: 'flex', flexDirection: 'column' }}>
      <Link to="/" className="brand">
        <img src={logo} alt="Maskan" className="brand-logo" />
      </Link>
      <nav>
        <NavLink end to="/" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconDashboard /></span><span>Dashboard</span>
        </NavLink>
        <NavLink to="/conversational-ai" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconVoice /></span><span>Conversational-AI</span>
        </NavLink>
        <NavLink to="/radiology" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconRadiology /></span><span>Radiology</span>
        </NavLink>
        <NavLink to="/Chatbot" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconChat /></span><span>Chatbot</span>
        </NavLink>
        <NavLink to="/whatsapp" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconWhatsApp /></span><span>WhatsApp Integration</span>
        </NavLink>
        <NavLink to="/ai-avatar" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconAvatar /></span><span>AI Avatar</span>
        </NavLink>
        <NavLink to="/docfussion" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconDoc /></span><span>DocFussion</span>
        </NavLink>
      </nav>
      <div style={{ marginTop: 'auto' }}>
        <NavLink to="/logout" className={({isActive}) => `nav-item ${isActive ? 'active' : ''}`}>
          <span className="icon"><IconLogout /></span><span>Logout</span>
        </NavLink>
      </div>
    </aside>
  );
}
